var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-right"},[_c('input',{staticClass:"form-control col-md-6",staticStyle:{"max-width":"100%"},attrs:{"type":"number"},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}})])}
var staticRenderFns = []

export { render, staticRenderFns }